export const useConsent = () => {
  const getConsent = () => {
    const saved = localStorage.getItem('cookieConsent');
    if (!saved) return null;
    try {
      return JSON.parse(saved);
    } catch {
      return null;
    }
  };

  const hasConsentForForms = () => {
    const consent = getConsent();
    return consent?.formsData === true;
  };

  return { getConsent, hasConsentForForms };
};